import React from "react";
import ReactDOM from "react-dom";
import './i18n';
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./index.css";
import 'bootstrap/dist/js/bootstrap.min.js';


ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
    document.getElementById("root")
);

serviceWorker.unregister();